import * as React from 'react';
import { useSelector } from 'react-redux';

import { Hero } from '../../components/Hero';
import { Risks } from '../../components/Risks';
import { Questions } from '../../components/Questions';
import { ReportExample } from '../../components/ReportExample';
import { ObjectTypeContainer } from '../ObjectTypeContainer';
import { LEGAL_CHECK_FORM_URL_WITH_SOURCE } from '../../constants/legalCheckFormUrl';
import { selectLegalCheckInfo } from '../../selectors/legalCheckInfo';

export const PageContainer: React.FC = () => {
  const { priceText, demoReportLink, oldPriceText, promoPriceText, termsOfPromotion, faq } =
    useSelector(selectLegalCheckInfo);

  return (
    <>
      <Hero
        buyLink={LEGAL_CHECK_FORM_URL_WITH_SOURCE}
        price={priceText}
        promoPriceText={promoPriceText}
        termsOfPromotion={termsOfPromotion}
        oldPrice={oldPriceText}
      />
      <Risks />
      <ReportExample
        reportExampleLink={demoReportLink}
        buyLink={LEGAL_CHECK_FORM_URL_WITH_SOURCE}
        price={priceText}
        promoPriceText={promoPriceText}
        termsOfPromotion={termsOfPromotion}
        oldPrice={oldPriceText}
      />
      <Questions questions={faq} />
      <ObjectTypeContainer />
    </>
  );
};

PageContainer.displayName = 'PageContainer';
